import { isWeixin, fenxiang, Base64, basepath } from '../../../assets/common/js/config'

/**拼团开团后分享参团 */
export function joinShare({ that, sharetitle, sharedesc, shareimg, id, code, isClick }) {
  if (!!sharetitle) {
    var base = new Base64()
    var tit = !!sharetitle ? sharetitle : '这个产品推荐给你，点击立享福利价。'
    var desc = !!sharedesc ? sharedesc : '快来参与吧！'
    var img = !!shareimg ? shareimg : basepath + 'wx/img/ptlogo.jpg'
    if (!isClick) {
      that.$app.argFunc(
        () => {
          fenxiang({
            title: encodeURIComponent(tit),
            desc: encodeURIComponent(desc),
            imgx: img,
            type: 'ptjoin',
            dataStr:
              'type=ptjoin&params=' +
              base.encode(JSON.stringify({ grouprecordid: id, code: code })),
            path: 'groupGrouppay'
          })
        },
        () => {
          that.$app.shareFriends({
            title: encodeURIComponent(tit),
            img: img,
            link:
              basepath +
              'static/wx/html/new-group/sharygroup.html?grouprecordid=' +
              id +
              '&code=' +
              code
          })
        }
      )
    } else {
      that.$app.argFunc(
        () => {
          if (isWeixin()) {
            that.showshare = true
          } else {
            that.$toast('请打开微信商城，邀请好友')
          }
        },
        () => {
          that.showshare = true
        },
        () => {
          that.$app.shareFriends(
            {
              title: encodeURIComponent(tit),
              desc: encodeURIComponent(desc),
              img: img,
              link: encodeURIComponent(
                that.$ajax.app_share_URL +
                  '&type=ptjoin&params=' +
                  +base.encode(JSON.stringify({ grouprecordid: id, code: code }))
              )
            },
            'app'
          )
        }
      )
    }
  }
}
/**申请售后前弹窗商品整合 */
export function refundGoodsList({ that, items, orderGoodsCheckHide }) {
  that.refundGoods = []
  if (that.afterSalesType == 0) {
    if (
      (items.isgift != 1 || (items.isgift == 1 && parseFloat(items.price || 0) > 0)) &&
      items.isprogift != 1 &&
      items.refundNum > 0
    ) {
      let curNum = items.refundNum
      that.refundGoods.push({ curNum: curNum, ...items })
    }
  } else {
    that.order.itemlist.forEach((item) => {
      if (
        (item.isgift != 1 || (item.isgift == 1 && parseFloat(item.price || 0) > 0)) &&
        item.isprogift != 1 &&
        item.refundNum > 0
      ) {
        let curNum = item.refundNum
        that.refundGoods.push({ curNum: curNum, ...item })
      }
    })
  }
  if (that.refundGoods.length > 0 && !orderGoodsCheckHide) {
    that.$refs.orderGoodsCheck.open()
  }
}

/**退款/售后方法处理 */
export function afterSalesHandle({ that, items }) {
  if (that.afterSalesType == 0 && that.order.is_part_refund == 0 && that.order.orderstatus == 2) {
    return that.$toast('当前时间暂时无法申请部分退款，请稍后再试！')
  }
  if (that.order.is_zg_order == 1) {
    return that.$toast('当前商品为专柜商品，不能申请售后')
  }
  if (that.order.is_refund == 0) {
    return that.$toast('您当前尚有申请售后的商品，不能同时申请')
  }
  if (that.order.is_changebuy_refund_tip) {
    that.$dialog
      .alert({
        message: that.order.is_changebuy_refund_tip,
        className: 'percen_button_alert',
        confirmButtonColor: '#FFFCFC',
        confirmButtonText: '知道了',
        closeOnPopstate: false
      })
      .then(function () {
        // on confirm
        Func()
      })
      .catch(function () {
        // on cancel
      })
  } else {
    Func()
  }
  function Func() {
    var url = that.$ajax.checkOrderRefund_URL + '?oid=' + that.order.id
    that.$customRequestAjax(url).then((res) => {
      if (res.data.code === 200) {
        refundGoodsList({ that, items })
      } else if (res.data.code == 6006) {
        that.afterSalesMessage = res.data.msg
        that.kefuPhone = res.data.phone
        that.afterSalesShow = true
      } else if (res.data.code == 6007) {
        that.$router.push({
          path: '/splitdetails',
          query: {
            id: that.order.id
          }
        })
      } else if (res.data.code == 6008) {
        that.$refs.pickerRef.show()
      }
    })
  }
}

/**申请售后前接口参数整合 */
export function refundGoods({ selectedList }) {
  var ordersheet_id = [],
    nums = []
  selectedList.forEach((item) => {
    if (item.curNum || 0) {
      ordersheet_id.push(item.ordersheet_id)
      nums.push(item.curNum)
    }
  })
  return {
    ordersheet_id: ordersheet_id.join(','),
    nums: nums.join(',')
  }
}

/**满额抽奖活动售后订单提示信息 */
export function refundActivityPrizeTip({ that, obj }) {
  var Func = () => {
    if (!that.order.prizetip) {
      that.$router.push({
        path: '/aftertype',
        query: {
          type: that.afterSalesType,
          oid: that.order.id,
          id: obj.ordersheet_id,
          nums: obj.nums,
          ...(obj.allrefund ? { allrefund: obj.allrefund } : {})
        }
      })
      return
    }
    var url1 =
      that.$ajax.getRefundActivityPrizeTip_URL +
      '?orderid=' +
      that.order.id +
      '&ordersheet_id=' +
      obj.ordersheet_id +
      '&nums=' +
      obj.nums

    that.$customRequestAjax(url1).then((res1) => {
      if (res1.data.code == 200 && res1.data.data.prizetip != '') {
        that.$dialog
          .confirm({
            message: res1.data.data.prizetip,
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnPopstate: true
          })
          .then(function () {
            // on confirm
            that.$router.push({
              path: '/aftertype',
              query: {
                type: that.afterSalesType,
                oid: that.order.id,
                id: obj.ordersheet_id,
                nums: obj.nums,
                ...(obj.allrefund ? { allrefund: obj.allrefund } : {})
              }
            })
          })
          .catch(function () {
            // on cancel
          })
      } else {
        that.$router.push({
          path: '/aftertype',
          query: {
            type: that.afterSalesType,
            oid: that.order.id,
            id: obj.ordersheet_id,
            nums: obj.nums,
            ...(obj.allrefund ? { allrefund: obj.allrefund } : {})
          }
        })
      }
    })
  }
  if (that.order.largeDenominationCoupon == 1) {
    var url =
      that.$ajax.largeCouponOrderApplyRefund_URL +
      '?orderId=' +
      that.order.id +
      '&ordersheet_id=' +
      obj.ordersheet_id +
      '&nums=' +
      obj.nums

    that.$customRequestAjax(url).then((res) => {
      if (res.data.code == 200) {
        Func()
      } else if (res.data.code == 300 || res.data.code == 400 || res.data.code == 500) {
        that.$dialog[res.data.code == 300 ? 'alert' : 'confirm']({
          message: res.data.msg,
          className: res.data.code == 300 ? 'percen_button_alert' : 'collect_button_alert',
          confirmButtonColor: '#FFFCFC',
          ...(res.data.code == 300
            ? { confirmButtonText: '我知道了', closeOnPopstate: false }
            : {
                cancelButtonColor: '#FC0324',
                cancelButtonText: '关闭',
                confirmButtonText: '继续',
                closeOnPopstate: true
              })
        })
          .then(function () {
            // on confirm
            if (res.data.code != 300) Func()
          })
          .catch(function () {
            // on cancel
          })
      }
    })
  } else {
    Func()
  }
}



// WEBPACK FOOTER //
// ./src/components/order/js/methods.js